import { MeshBasicNodeMaterial, BackSide } from 'three/webgpu'
import { uniform, positionLocal, positionView, normalLocal, smoothstep, fwidth, max, float, vec3 } from 'three/tsl'

export default class GridMaterial extends MeshBasicNodeMaterial {
	static defaults = {
		color: 0xffffff,
		density: 1,
		lineWidth: 1.2,
		speed: 0.35,
		near: 0,
		far: 15,
		detail: 0.35,
		overallOpacity: 0.05,
	}

	constructor(options = {}) {
		const { color, density, lineWidth, speed, near, far, detail, overallOpacity } = {
			...GridMaterial.defaults,
			...options,
		}

		super({ color, transparent: true, depthWrite: false, side: BackSide })

		this.speed = speed
		this._time = uniform(0)
		this._opacity = uniform(0)

		const cell = positionLocal.mul(density).add(vec3(0, 0, this._time))
		const width = fwidth(cell).max(float(0.0001))
		const distance = float(0.5).sub(cell.fract().sub(0.5).abs()).div(width)
		const lines = float(1).sub(distance.div(lineWidth)).saturate().mul(normalLocal.abs().oneMinus())
		const strength = max(max(lines.x, lines.y), lines.z)
		const legible = smoothstep(detail, detail * 0.3, max(max(width.x, width.y), width.z))
		const fade = smoothstep(far, near, positionView.z.negate())

		this.opacityNode = strength.mul(fade).mul(legible).mul(this._opacity).mul(overallOpacity)
	}

	set time(value) {
		this._time.value = value * this.speed
	}

	set progress(value) {
		this._opacity.value = value
	}
}
